var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9868 31.7091C9.47378 23.8783 9.4678 11.1861 16.9699 3.34784C15.0773 4.3265 13.36 5.61246 11.8883 7.15292L11.8868 7.15391C4.36781 14.9907 4.36781 27.6969 11.8868 35.5341L25.5034 49.725L29.8882 45.1549L16.9868 31.7091Z",
    fill: "#D4E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5036 30.7315C19.1659 30.7315 14.0286 25.5937 14.0286 19.2565C14.0286 12.9189 19.1659 7.78149 25.5036 7.78149C31.8407 7.78149 36.9786 12.9189 36.9786 19.2565C36.9786 25.5937 31.8407 30.7315 25.5036 30.7315ZM25.5036 10.3315C20.5744 10.3315 16.5786 14.3273 16.5786 19.2565C16.5786 24.1857 20.5744 28.1815 25.5036 28.1815C30.4327 28.1815 34.4286 24.1857 34.4286 19.2565C34.4286 14.3273 30.4327 10.3315 25.5036 10.3315Z",
    fill: "#1AE5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5034 51C25.1558 51 24.8236 50.8586 24.583 50.6075L10.9669 36.4167C7.10106 32.3875 4.97241 27.035 4.97241 21.3438C4.97241 15.6531 7.10156 10.3001 10.9669 6.27141L10.9739 6.26394C14.8527 2.22428 20.0124 0 25.5034 0C30.9944 0 36.1541 2.22478 40.0329 6.26443L40.0394 6.27141C43.9052 10.3001 46.0339 15.6531 46.0339 21.3438C46.0339 27.035 43.9047 32.3875 40.0394 36.4167L26.4233 50.6075C26.1827 50.8581 25.8505 51 25.5034 51ZM12.8012 8.04246C5.7663 15.3807 5.76829 27.3154 12.8072 34.6516L25.5034 47.8832L38.1996 34.6511C45.238 27.3154 45.2395 15.3802 38.2046 8.04196L38.1981 8.03549C34.8044 4.49786 30.2956 2.55 25.5034 2.55C20.7107 2.55 16.2024 4.49786 12.8082 8.03549L12.8012 8.04246Z",
    fill: "#0635C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.2dba8d6e46d7ace0f584fa51bed72f5e.svg";
export { ForwardRef as ReactComponent };